const STYLES = {
  pending: "border-amber-400/50 text-amber-300",
  approved: "border-sky-400/50 text-sky-300",
  payment_submitted: "border-violet-300/50 text-violet-200",
  confirmed: "border-emerald-400/50 text-emerald-300",
  declined: "border-rose-400/50 text-rose-300",
};

export const StatusBadge = ({ status, label }) => (
  <span data-testid="booking-status-badge" className={`inline-block border px-3 py-1 text-xs uppercase tracking-[0.15em] ${STYLES[status] || ""}`}>
    {label}
  </span>
);
